import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { RView1jxdnn5qf89cm as RView } from '../RView.commonHtml.mjs';
import { ClickableSemantic_getInstance2dwzbc0ganf8f as ClickableSemantic_getInstance } from '../../models/Theme.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { get_pageNavigator1inl9j7ja0vlf as get_pageNavigator } from '../../navigation/Navigator.mjs';
import { Companion_instance15pczmasjuxgh as Companion_instance } from './ContainingView.commonHtml.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_invoke__zhh2q8($this, $this$launch, $completion) {
  var tmp = $this.nbu_1($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_0($this, $this$launch, $completion) {
  var tmp0_safe_receiver = $this.dbw_1.bbw_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    var tmp = tmp0_safe_receiver($completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  if ($this.dbw_1.abw_1) {
    $this.dbw_1.ybv_1.gbw($this.ebw_1);
  } else {
    $this.dbw_1.ybv_1.fbw($this.ebw_1);
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_1($this, $this$launch, $completion) {
  var tmp = $this.hbw_1($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_2($this, $this$launch, $completion) {
  var tmp0_safe_receiver = $this.ibw_1.bbw_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    var tmp = tmp0_safe_receiver($completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  if ($this.ibw_1.abw_1) {
    $this.ibw_1.ybv_1.gbw($this.jbw_1);
  } else {
    $this.ibw_1.ybv_1.fbw($this.jbw_1);
  }
  return Unit_instance;
}
var Link$lambda$slambdaClass;
function Link$lambda$slambda() {
  if (Link$lambda$slambdaClass === VOID) {
    class $ {
      constructor($it) {
        this.nbu_1 = $it;
      }
      yah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    Link$lambda$slambdaClass = $;
  }
  return Link$lambda$slambdaClass;
}
function Link$lambda$slambda_0($it) {
  var i = new (Link$lambda$slambda())($it);
  var l = ($this$launch, $completion) => i.yah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var Link$lambda$slambdaClass_0;
function Link$lambda$slambda_1() {
  if (Link$lambda$slambdaClass_0 === VOID) {
    class $ {
      constructor(this$0, $destination) {
        this.dbw_1 = this$0;
        this.ebw_1 = $destination;
      }
      yah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    Link$lambda$slambdaClass_0 = $;
  }
  return Link$lambda$slambdaClass_0;
}
function Link$lambda$slambda_2(this$0, $destination) {
  var i = new (Link$lambda$slambda_1())(this$0, $destination);
  var l = ($this$launch, $completion) => i.yah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var Link$lambda$slambdaClass_1;
function Link$lambda$slambda_3() {
  if (Link$lambda$slambdaClass_1 === VOID) {
    class $ {
      constructor($it) {
        this.hbw_1 = $it;
      }
      yah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    Link$lambda$slambdaClass_1 = $;
  }
  return Link$lambda$slambdaClass_1;
}
function Link$lambda$slambda_4($it) {
  var i = new (Link$lambda$slambda_3())($it);
  var l = ($this$launch, $completion) => i.yah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var Link$lambda$slambdaClass_2;
function Link$lambda$slambda_5() {
  if (Link$lambda$slambdaClass_2 === VOID) {
    class $ {
      constructor(this$0, $destination) {
        this.ibw_1 = this$0;
        this.jbw_1 = $destination;
      }
      yah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    Link$lambda$slambdaClass_2 = $;
  }
  return Link$lambda$slambdaClass_2;
}
function Link$lambda$slambda_6(this$0, $destination) {
  var i = new (Link$lambda$slambda_5())(this$0, $destination);
  var l = ($this$launch, $completion) => i.yah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var LinkClass;
function Link() {
  if (LinkClass === VOID) {
    class $ extends RView() {
      constructor(context) {
        super(context);
        this.lba(this.qb6_1.abf(ClickableSemantic_getInstance()));
        this.vb5_1.zb3_1 = 'a';
        this.vb5_1.jb4_1.v('kiteui-stack');
        this.vb5_1.jb4_1.v('clickable');
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.addEventListener' call
        var this_0 = this.vb5_1;
        var tmp0_safe_receiver = this_0.xb3_1;
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          tmp0_safe_receiver.addEventListener('click', (it) => {
            $l$block: {
              var tmp0_safe_receiver = this.cbw_1;
              if (tmp0_safe_receiver == null)
                null;
              else {
                // Inline function 'kotlin.let' call
                launch(this, VOID, VOID, Link$lambda$slambda_0(tmp0_safe_receiver));
              }
              // Inline function 'com.lightningkite.kiteui.views.direct.Link.newTab' call
              // Inline function 'com.lightningkite.kiteui.views.target' call
              var tmp = this.vb5_1.bb4_1.kb7_1.target;
              if (((!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : null) === '_blank') {
                break $l$block;
              }
              it.preventDefault();
              var tmp1_safe_receiver = this.zbv_1;
              var destination = tmp1_safe_receiver == null ? null : tmp1_safe_receiver();
              if (!(destination == null)) {
                launch(this, VOID, VOID, Link$lambda$slambda_2(this, destination));
              }
            }
            return Unit_instance;
          });
          tmp = Unit_instance;
        }
        if (tmp == null) {
          // Inline function 'kotlin.run' call
          var tmp_0 = this_0.gb4_1['on' + 'click'];
          var old = (!(tmp_0 == null) ? typeof tmp_0 === 'function' : false) ? tmp_0 : null;
          var tmp_1 = 'on' + 'click';
          this_0.gb4_1[tmp_1] = (it) => {
            var tmp0_safe_receiver = old;
            if (tmp0_safe_receiver == null)
              null;
            else
              tmp0_safe_receiver(it);
            $l$block_0: {
              var tmp0_safe_receiver_0 = this.cbw_1;
              if (tmp0_safe_receiver_0 == null)
                null;
              else {
                // Inline function 'kotlin.let' call
                launch(this, VOID, VOID, Link$lambda$slambda_4(tmp0_safe_receiver_0));
              }
              // Inline function 'com.lightningkite.kiteui.views.direct.Link.newTab' call
              // Inline function 'com.lightningkite.kiteui.views.target' call
              var tmp = this.vb5_1.bb4_1.kb7_1.target;
              if (((!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : null) === '_blank') {
                break $l$block_0;
              }
              it.preventDefault();
              var tmp1_safe_receiver = this.zbv_1;
              var destination = tmp1_safe_receiver == null ? null : tmp1_safe_receiver();
              if (!(destination == null)) {
                launch(this, VOID, VOID, Link$lambda$slambda_6(this, destination));
              }
            }
            return Unit_instance;
          };
        }
        var tmp_2 = this;
        tmp_2.ybv_1 = get_pageNavigator(this instanceof RView() ? this : THROW_CCE());
        this.zbv_1 = null;
        this.abw_1 = false;
        this.bbw_1 = null;
        this.cbw_1 = null;
      }
      wb9(index, view) {
        super.wb9(index, view);
        Companion_instance.nbg(this, index, view);
      }
      kbw(value) {
        this.zbv_1 = value;
        var tmp1_safe_receiver = value == null ? null : value();
        var tmp;
        if (tmp1_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          var tmp0_safe_receiver = this.ybv_1.lbw().pbw(tmp1_safe_receiver);
          var tmp_0;
          if (tmp0_safe_receiver == null) {
            tmp_0 = null;
          } else {
            // Inline function 'kotlin.let' call
            var tmp0 = this.vb5_1.bb4_1;
            // Inline function 'com.lightningkite.kiteui.views.href' call
            var value_0 = this.pc().ob3_1 + tmp0_safe_receiver.qbw_1.ubw();
            tmp0.kb7_1.href = value_0;
            tmp_0 = Unit_instance;
          }
          tmp = tmp_0;
        }
        if (tmp == null) {
          // Inline function 'kotlin.run' call
          // Inline function 'com.lightningkite.kiteui.views.href' call
          this.vb5_1.bb4_1.kb7_1.href = '';
        }
      }
      vbw(action) {
        this.bbw_1 = action;
      }
    }
    initMetadataForClass($, 'Link');
    LinkClass = $;
  }
  return LinkClass;
}
//region block: exports
export {
  Link as Link2eefk0yp041c4,
};
//endregion

//# sourceMappingURL=Link.commonHtml.mjs.map
